import {app} from '../app'

import {convertAllUmlats, hasInvalidCharOrUmlat, isAllowChar, normalizeText} from 'tfx-common/api/functions'
import {showTimedTooltip} from '@/common/api/tooltips'

const ckEditorConfig = {
  toolbarGroups: [
    {name: 'document', groups: ['mode', 'document', 'doctools']},
    {name: 'clipboard', groups: ['clipboard', 'undo']},
    {name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing']},
    {name: 'forms', groups: ['forms']},
    {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
    {name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']},
    {name: 'links', groups: ['links']},
    {name: 'insert', groups: ['insert']},
    {name: 'styles', groups: ['styles']},
    {name: 'colors', groups: ['colors']},
    {name: 'tools', groups: ['tools']},
    {name: 'others', groups: ['others']},
    {name: 'about', groups: ['about']}
  ],
  language: 'en',
  allowedContent: true,
  scayt_autoStartup: true,
  // eslint-disable-next-line no-multi-str
  removeButtons: 'Source,Paste,PasteText,Blockquote,Save,NewPage,Preview,Print,\
    PasteFromWord,Templates,Find,Replace,SelectAll,Form,Checkbox,Radio,Textarea,TextField,\
    Select,ImageButton,Button,HiddenField,Subscript,Superscript,CreateDiv,BidiRtl,Language,\
    BidiLtr,Anchor,Flash,Table,HorizontalRule,SpecialChar,PageBreak,Iframe,Styles,Format,Maximize,ShowBlocks,About',
  removePlugins: 'elementspath, resize',
  height: 'auto',
  versionCheck: false
}

const consultationToolbar = {
  toolbarGroups: [
    {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
    {name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi']}
  ]
}

const setupNonAnsiiSym = function (editor) {
  editor.on('key', (e) => {
    if (!isAllowChar(e.data.domEvent.$.key)) {
      const cke = document.getElementsByClassName('cke')[0]
      showTimedTooltip(cke, 'You entered invalid character.', 'only-latin-char')
      e.cancel()
    }
  })
  editor.on('paste', (e) => {
    if (e.data.type === 'html') {
      const realValue = e.data.dataValue
      if (hasInvalidCharOrUmlat(realValue)) {
        const newValue = convertAllUmlats(normalizeText(realValue))
        if (realValue !== newValue) {
          e.data.dataValue = newValue
          const cke = document.getElementsByClassName('cke')[0]

          // eslint-disable-next-line no-multi-str
          const text = 'Oh-oh. It looks like you used a non-English character. \
            Unfortunately IRS only accepts English characters, so we had to remove all symbols that don\'t comply with IRS \
            rules and replace them with English equivalents.'
          if (!backtickTest(realValue, newValue)) {
            showTimedTooltip(cke, text, 'only-latin-char')
          }
        }
      }
    }
  })
}

const backtickTest = function (text, filtered) {
  const replaced = text.replace(/�/g, '\'')
  return (filtered === replaced)
}

const mounted = (el) => {
  app.Plugin.use('ckeditor', () => {
    let config = ckEditorConfig
    if (el.dataset.toolbar === 'consultationToolbar') {
      config = Object.assign(config, consultationToolbar)
    }
    if (el.dataset.needSource) {
      config = Object.assign({}, config)
      config.removeButtons = config.removeButtons.replace('Source,', '')
    }
    if (el.dataset.height) {
      config.height = el.dataset.height
    }
    const editor = window.CKEDITOR.replace(el, config)
    el.dataset.editor = editor
    setupNonAnsiiSym(editor)
    el.parentElement.classList.toggle('tfx-ckeditor-wrapper')
  })
}

const unmounted = (el) => {
  const editor = el.dataset.editor
  if (editor) {
    el.dataset.editor = undefined
    // editor.destroy(true)
    window.CKEDITOR.remove(editor)
  }
}

export default {
  mounted,
  unmounted
}
